import React, {Component} from 'react';
import './App.css';
import {Redirect, Route, Switch, withRouter} from 'react-router-dom';
import EnableProgram from "./components/enable-program/EnableProgram";
import NodeStatus from "./components/node-summary/NodeSummary";
import EditConfiguration from "./components/edit-config/EditConfig";
import ProgramLaunchStatus from "./components/program-launch-status/ProgramLaunchStatus";
import ManagePrograms from "./components/manage-programs/ManagePrograms";
import {DEFAULT_ROUTES} from "./components/util/RouteConstants";

class App extends Component {
    render() {
        return (
            <Switch>
                {Object.keys(DEFAULT_ROUTES).map((path, index) => {
                    return <Route exact path={path} key={index}>
                        <Redirect to={DEFAULT_ROUTES[path]}/>
                    </Route>
                })}
                {/* Main Routes */}
                <Route path="/enableprogram" component={EnableProgram} />
                <Route path="/manageprograms" component={ManagePrograms} />

                {/* Other Routes */}
                <Route path="/nodesummary" component={NodeStatus} />
                <Route path="/editconfig" component={EditConfiguration} />
                <Route path="/programlaunchstatus" component={ProgramLaunchStatus}/>
            </Switch>
        );
    }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js